import React from 'react';
import './CountReportCard.scss';
import { EggsSVG, MilkCartonSVG } from '../ChikaExportSvg/ChikaExportSvg';

const CountReportCard = ({ icon, title, bgIcon, egg, pack, className }) => {
  return (
    <div className={`countReportCard ${className || ""}`}>
      <div className="countReportCardHeader">
        <div className='countReportCardTexts'>
          <h3 className="countReportCardTitle">{title}</h3>
        </div>
        <div className="countReportCardIcon" style={{ backgroundColor: bgIcon }}>
          {icon}
        </div>
      </div>
      <div className="countReportCardValues">
        {egg !== undefined && (
          <div className="countReportCardValue">
            <EggsSVG />
            <span>{egg || 0}</span>
          </div>
        )}
        {pack !== undefined && (
          <div className="countReportCardValue">
            <MilkCartonSVG />
            <span>{pack || 0}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountReportCard;